import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./footer.module.css";
import img1 from "../../assets/imgs/dental cabinet logo.png";
import img3 from "../../assets/imgs/Dental Secrets Jpg.jpg";
import { Link } from "react-router-dom";
import facebook from "../../assets/imgs/Icons/Asset 1.png";
import instagram from "../../assets/imgs/Icons/Asset 2.png";
import twitter from "../../assets/imgs/Icons/Asset 3.png";
import whatsApp from "../../assets/imgs/Icons/Asset 6.png";
import logo from "../../assets/imgs/Group 7.png";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [t, i18n] = useTranslation();

  return (
    <div className={classes.footer}>
      <Container fluid>
        <Row>
          <Col xs={4}>
            <div className={classes.logoConainer}>
              <a
                href="https://dentalcabinetegypt.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={img1} alt="" />
              </a>
              <a
                href="http://secrets.dentalcabinetegypt.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={img3} alt="" />
              </a>
            </div>
          </Col>
          <Col xs={4} className={classes.colLinks}>
            <div
              className={classes.links}
              style={{
                direction: `${t("home") === "الرئيسية" ? "rtl" : "ltr"}`,
              }}
            >
              <Link to="/">{t("home")}</Link>
              <Link to="/aboutus">{t("about-us")}</Link>
              <Link to="/gallery/1">{t("gallary")}</Link>
            </div>
          </Col>
          <Col xs={4} className={classes.colMedia}>
            <div className={classes.media}>
              <a
                href="https://www.facebook.com/share/AqRdriRDxX2EqFMB/?mibextid=LQQJ4d"
                target="_blank"
                rel="noreferrer"
              >
                <img src={facebook} alt="facebook logo" />
              </a>
              <a
                href="https://www.instagram.com/cigroup.eg"
                target="_blank"
                rel="noreferrer"
              >
                <img src={instagram} alt="instagram logo" />
              </a>
              <a
                href="https://wa.me/+201004234676"
                target="_blank"
                rel="noreferrer"
              >
                <img src={whatsApp} alt="whatsapp logo" />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
      <div className={classes.footerCopyright}>
        <p>
          Copyright &copy;{" "}
          <a target="_blank" href="https://teqneia.com/">
            TEQNEIA
          </a>{" "}
          2015-2022{" "}
        </p>
      </div>
    </div>
  );
};

export default Footer;
